angular.module('unergie.main')
.controller('b2gBillingDashboardCtrl', ($scope, DataAccess, AlertManager, ApiUser, TableGeneratorService, FileUploader, FilterMapping, ErrorCatcher) => {
    $scope.antiBooleanFilter = [{ id: 'false', title: 'Oui' }, { id: 'true', title: 'Non' }]
    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]
    $scope.invoiceStatuses = FilterMapping.invoiceStatuses

    $scope.b2gBalance = {
        refreshing: false,
        show: {
            siret: true,
            id_accounts: true,
            brands: true,
            invoiced: true,
            owed: true,
            paid: true,
            balance: true,
        },
    }

    $scope.b2gBalance.columns = {
        siret: { label: 'SIRET', mode: 'search_wildcard', mandatory: true },
        id_accounts: { label: 'Id account', mode: 'hidden', csvIgnore: true },
        brands: { label: 'Comptes', mode: 'search_wildcard', translateCsv: 'Comptes' },
        invoiced: { label: 'Libellé', mode: 'search_operator', translateCsv: 'Facturé' },
        owed: { label: 'Libellé', mode: 'search_operator', translateCsv: 'Dû' },
        paid: { label: 'Date', mode: 'search_operator', translateCsv: 'Payé' },
        balance: { label: 'Date', mode: 'search_operator', translateCsv: 'Solde' },
    }

    const metaInvoicesColumns = {
        siret: { label: 'SIRET', mode: 'search_wildcard' },
        id: { label: 'ID', mode: 'search_operator' },
        pdf_path: { label: 'PDF', mode: 'search_wildcard' },
        pdf_fees_path: { label: 'PDF Frais', mode: 'search_wildcard' },
        xlsx_path: { label: 'XLSX', mode: 'search_wildcard' },
        zip_path: { label: 'ZIP', mode: 'search_wildcard' },
        invoice_number: { label: 'N° Facture', mode: 'search_wildcard' },
        status: { label: 'Status', mode: 'search_operator' },
        invoice_date: { label: 'Date Facture', mode: 'search_date' },
        period_start_date: { label: 'Début', mode: 'search_date' },
        period_end_date: { label: 'Fin', mode: 'search_date' },
        total: { label: 'Total', mode: 'search_operator' },
        reversal_of: { label: 'Extourne', mode: 'hidden' },
        external_status: { label: 'Statut Chorus', mode: 'search_wildcard' },
    }

    const paymentsColumns = {
        payment_date: { label: 'Début', mode: 'search_date' },
        siret: { label: 'SIRET', mode: 'search_wildcard' },
        mode: { label: 'Mode', mode: 'search_wildcard' },
        type: { label: 'Type', mode: 'search_wildcard' },
        cancelled: { label: 'Annulé', mode: 'search_strict' },
        invoice_number: { label: 'Annulé', mode: 'search_wildcard' },
        amount: { label: 'Montant', mode: 'search_operator' },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.b2gBalance, 'b2g-balance', null, null, { orderBy: 'siret' })

    // UPLOADER
    $scope.transferUploader = new FileUploader({
        url: `/api-admin/s3-upload`,
        alias: 'file',
        formData: [{ bucketName: 'files', path: 'b2g-payments/transfer' }],
        autoUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Fichier de virements uploadé`)
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    $scope.sepaUploader = new FileUploader({
        url: `/api-admin/s3-upload`,
        alias: 'file',
        formData: [{ bucketName: 'files', path: 'b2g-payments/sepa' }],
        autoUpload: true,
        method: 'POST',
        onSuccessItem(item, response, status, headers) {
            AlertManager.success(`Fichier de prélèvements uploadé`)
        },
        onErrorItem(item, response, status, headers) {
            AlertManager.error(response.message, 10000)
        },
    })

    $scope.expandBalance = (balance) => {
        if (!balance.refreshing) {
            balance.expanded = !balance.expanded
            if (!balance.fetched) {
                return $scope.fetchBalanceDetails(balance)
            }
        }
    }

    $scope.getMetaInvoicesForSiret = (balance) => {
        balance.metas = {
            columns: _.clone(metaInvoicesColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(balance.metas, 'vw-meta-invoices', null, null, { search: { siret: balance.siret } })
    }

    $scope.getPaymentsForSiret = (balance) => {
        balance.payments = {
            columns: _.clone(paymentsColumns),
            preventAddressBar: true,
        }
        return TableGeneratorService.getTable(balance.payments, 'b2g-payments', null, null, { search: { siret: balance.siret } })
    }

    $scope.fetchBalanceDetails = (balance) => {
        $scope.getMetaInvoicesForSiret(balance)
        $scope.getPaymentsForSiret(balance)
    }

    $scope.reconcile = (balance) => {
        if (!balance.reconciling) {
            balance.reconciling = true
            return DataAccess.reconcileB2gPayments({ siret: balance.siret }, {}).$promise.then((result) => {
                AlertManager.success(`Réconciliation terminée, SIRET trouvé : ${result.siret}`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                balance.reconciling = false
                $scope.refresh()
            })
        }
    }

    // CHANGE INVOICE NUMBER
    $scope.changeInvoiceNumberTemplate = {
        invoice_number: '',
    }

    $scope.changeInvoiceNumberFields = {
        invoice_number: {
            label: 'Numéro facture',
            required: true,
            type: 'text',
        },
    }

    $scope.updateInvoiceNumberTemplate = (invoice_number) => {
        $scope.changeInvoiceNumberTemplate.invoice_number = invoice_number
    }

    $scope.changeInvoiceNumber = (payment) => {
        if (!payment.modifying) {
            payment.modifying = true
            return DataAccess.updateB2gPaymentInvoiceNumber({ id: payment.id, invoice_number: $scope.changeInvoiceNumberTemplate.invoice_number }, {}).$promise.then((result) => {
                AlertManager.success(`Modification effectuée`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                payment.modifying = false
                $scope.refresh()
            })
        }
    }

    // CHANGE SIRET
    $scope.changeSiretTemplate = {
        siret: '',
    }

    $scope.changeSiretFields = {
        siret: {
            label: 'SIRET',
            required: true,
            type: 'text',
        },
    }

    $scope.updateSiretTemplate = (siret) => {
        $scope.changeSiretTemplate.siret = siret
    }

    $scope.changeSiret = (payment) => {
        if (!payment.modifying) {
            payment.modifying = true
            return DataAccess.updateB2gPayment({ id: payment.id }, { siret: $scope.changeSiretTemplate.siret }).$promise.then((result) => {
                AlertManager.success(`Modification effectuée`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                payment.modifying = false
                $scope.refresh()
            })
        }
    }

    $scope.changeSiretForAll = (balance) => {
        if (!balance.modifying) {
            balance.modifying = true
            const payload = _.map(balance.payments.instance.data, (data) => {
                return { id: data.id, siret: $scope.changeSiretTemplate.siret }
            })
            return DataAccess.massUpdateB2gPayment({}, payload).$promise.then((result) => {
                AlertManager.success(`Modification effectuée`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                balance.modifying = false
                $scope.refresh()
            })
        }
    }

    // PENALTY EMAIL
    $scope.penaltyReminderFields = { force: { label: `Forcer l'envoi`, type: 'checkbox' } }

    $scope.sendPenaltyReminder = (balance, index) => {
        const id_account = balance.id_accounts.split(',')[index]
        if (!balance.sending) {
            balance.sending = true
            return ApiUser.sendPenaltyReminder({ id_account, force: balance.force }, {}).$promise.then((result) => {
                AlertManager.success(`Email envoyé`)
            })
            .catch(ErrorCatcher)
            .finally(() => {
                balance.sending = false
            })
        }
    }

    $scope.refresh()
})
